






























import { PhysicalAddress, Place } from 'inscreva-sse-models';
import { Component, Vue, Prop } from 'vue-property-decorator';

import LocationMap from './LocationMap.vue';

@Component({
  components: {
    LocationMap,
  },
})
export default class EventInfoPlaceComponent extends Vue {
  @Prop({ required: true })
  private place!: Place | string;

  @Prop({ required: true })
  private isOnline!: boolean;

  @Prop()
  alias: string;

  private showMap = false;

  get is_place_string(): boolean {
    return typeof this.place === 'string';
  }

  get is_place_address(): boolean {
    return !this.is_place_string && !!(this.place as PhysicalAddress).address;
  }

  get eventLink() {
    return `${window.location.origin}/${this.alias}`;
  }
}
